export enum CommunicationMethod {
  EMAIL = 1,
  TEXT_MESSAGE = 2,
  PUSH_NOTIFICATION = 3,
}
